import dayjs from "dayjs";

export const generateTimeOptions = ({ minutesStep = 15 }) => {
  const options = [];
  const totalMinutes = 24 * 60;
  const baseDate = dayjs().startOf("day");

  for (let minutes = 0; minutes < totalMinutes; minutes += minutesStep) {
    const time = baseDate.add(minutes, "minute");
    options.push({
      label: time.format("hh:mm a"),
      value: time,
      minutes,
    });
  }

  return options;
};

export const formatDuration = (durationMinutes) => {
  if (durationMinutes < 60) {
    return `${durationMinutes} min`;
  }
  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;
  if (minutes === 0) {
    return `${hours} ${hours === 1 ? "hr" : "hrs"}`;
  }
  return `${hours} hrs ${minutes} min`;
};
